<template>
  <v-card
    height="100"
    width="250"
    padding="0"
    margin="0"
    class="ma-4"
    color="pink darken-2"
  >
    <v-card-text class="d-flex white--text justify-space-between align-center">
      <div style="font-size:14px;">
        <v-icon color="white">mdi-cash-check</v-icon>
        <strong> {{ title }}</strong> <br>
        <!-- <span>Last 3 weeks</span> -->
      </div>
      <!-- <v-avatar
            size="60"
            :color="color"
            style="border: 3px solid #444"
          >
            <span style="color: white">R$ {{ amount }}</span>
          </v-avatar> -->
    </v-card-text>
    <v-card-actions class="d-flexResult white--text">
      {{ amount }}
    </v-card-actions>
  </v-card>
</template>

<script>
import Cookie from 'js-cookie'
import api from './../../../../plugins/api'
import VueJwtDecode from 'vue-jwt-decode'
export default {
  name: 'TotalMensal',
  data () {
    return {
      title: '',
      amount: '',
      icon: 'mdi-account',
      color: 'cyan lighten-3',
      objSession: []
    }
  },
  // computed: {
  //   valor: function () {
  //     return this.amount
  //   }
  // },
  watch: {
    options: {
      handler () {

      },
      deep: true
    }
  },
  mounted () {
    this.getTotalOfertraMes()
  },
  methods: {
    getTotalOfertraMes () {
      const getToken = Cookie.get('token')
      const decriptToken = VueJwtDecode.decode(getToken)
      // console.log('id_church', decriptToken)
      // this.objSession = JSON.parse(sessionStorage.getItem('Sessão teste'))
      api.get('/financeiro/TotalOfertaMissoes/' + Number(decriptToken.id_church)).then((response) => {
        let valor = response.data.objeto
        this.title = 'Total Oferta Missões'
        this.amount = valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
      })
    }
  }
}
</script>

<style scoped>
.d-flexResult{
  padding-left: 20px;
  padding-right: 20px;
}
</style>
